// QA uses the same non-prod URLs and OAuth client as dev.
// This is intentional — both environments share the IT/non-prod gateway and auth.
// The QA file exists to allow divergence when needed (e.g., QA-specific feature flags).

export const environment = {
  production: false,
  federationManifest: '/ui-shell/federation.manifest.json',
  hostRemoteEntry: '/ui-shell/remoteEntry.json',
  host: 'https://developerit.capitalone.com',
  redirectMatch:
    /https:\/\/(devexchange-cf\.clouddqtext\.capitalone\.com|developerit\.capitalone\.com|localhost(:\d+)|developer\.capitalone\.com)/,
  authorization_client_id: 'ae2f51500f144406b37d18f786f37f2b',
} as const;

export const timeouts = {
  http: 30000,
  appDeletion: 60000,
} as const;
